'use client'

import React from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import {
   Navigation,
   Pagination,
   Autoplay,
   EffectCoverflow,
   Keyboard,
} from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import 'swiper/css/effect-coverflow'

export default function BreakingDownSection() {
   return (
      <section className="container-fluid section_primary_bg">
         <div className="container text-center mb-4 innovation_comman blockchain_innovation">
            <h2 className="tech_title section_heading_title mb-2">
               Breaking Down AI/ML Services:
            </h2>
            <h2 className="tech_title section_heading_title mb-2">
               What AI/ML Services Do You Really Need?
            </h2>
            <p className="sub_body">
               Taking advantage of experience in handling nascent technologies, our AI & ML developers create robust pieces of software to enable you to make intelligent choices, taking your business to new heights of success.
            </p>
         </div>

         <div className="container text-center ai-ml-service-container">
            <div className="features_row mb-3 text-start ai-ml-service">
               <div className="service_card card_1">
                  <div className="service_card_title">
                     <h3>Language & Text Processing</h3>
                     <p className="service_card_sub">
                        AI that makes machines capable of comprehending, creating, and processing human language, such as text and speech synthesis.
                     </p>
                  </div>
                  <div className="ai-ml_card_border"></div>
                  <ul className="service-list">
                     <li className="service-item">
                        <div className="icon">
                           <img
                              src="/assets/svg/service/lang1.svg"
                              width="24"
                              height="24"
                           />
                        </div>
                        <div className="service-description">
                           Text-to-Speech (TTS)
                        </div>
                     </li>
                     <li className="service-item">
                        <div className="icon">
                           <img
                              src="/assets/svg/service/lang2.svg"
                              width="24"
                              height="24"
                           />
                        </div>
                        <div className="service-description">
                           SLM (Small Language Model)
                        </div>
                     </li>
                     <li className="service-item">
                        <div className="icon">
                           <img
                              src="/assets/svg/service/lang3.svg"
                              width="24"
                              height="24"
                           />
                        </div>
                        <div className="service-description">
                           LLM (Large Language Model)
                        </div>
                     </li>
                     <li className="service-item">
                        <div className="icon">
                           <img
                              src="/assets/svg/service/lang4.svg"
                              width="24"
                              height="24"
                           />
                        </div>
                        <div className="service-description">
                           NLP (Natural Language Processing)
                        </div>
                     </li>
                     <li className="service-item">
                        <div className="icon">
                           <img
                              src="/assets/svg/service/lang5.svg"
                              width="24"
                              height="24"
                           />
                        </div>
                        <div className="service-description">
                           RAG (Retrieval-Augmented Generation)
                        </div>
                     </li>
                     <li className="service-item">
                        <div className="icon">
                           <img
                              src="/assets/svg/service/lang6.svg"
                              width="24"
                              height="24"
                           />
                        </div>
                        <div className="service-description">
                           TLM (Transformers-Based Language Models)
                        </div>
                     </li>
                  </ul>
               </div>
               <div className="service_card card_2">
                  <div className="service_card_title">
                     <h3>Vision & Image Processing</h3>
                     <p className="service_card_sub">
                        AI that interprets visual data from images and videos,
                        enabling applications like object detection, facial
                        recognition & image generation.
                     </p>
                  </div>
                  <div className="ai-ml_card_border"></div>
                  <ul className="service-list">
                     <li className="service-item">
                        <div className="icon">
                           <img
                              src="/assets/svg/service/vision1.svg"
                              width="24"
                              height="24"
                           />
                        </div>
                        <div className="service-description">
                           Object Detection
                        </div>
                     </li>
                     <li className="service-item">
                        <div className="icon">
                           <img
                              src="/assets/svg/service/vision2.svg"
                              width="24"
                              height="24"
                           />
                        </div>
                        <div className="service-description">
                           Diffusion Models
                        </div>
                     </li>
                     <li className="service-item">
                        <div className="icon">
                           <img
                              src="/assets/svg/service/vision3.svg"
                              width="24"
                              height="24"
                           />
                        </div>
                        <div className="service-description">
                           Image Segmentation
                        </div>
                     </li>
                     <li className="service-item">
                        <div className="icon">
                           <img
                              src="/assets/svg/service/vision4.svg"
                              width="24"
                              height="24"
                           />
                        </div>
                        <div className="service-description">
                           CV (Computer Vision)
                        </div>
                     </li>
                     <li className="service-item">
                        <div className="icon">
                           <img
                              src="/assets/svg/service/vision5.svg"
                              width="24"
                              height="24"
                           />
                        </div>
                        <div className="service-description">
                           OCR (Optical Character Recognition)
                        </div>
                     </li>
                     <li className="service-item">
                        <div className="icon">
                           <img
                              src="/assets/svg/service/vision6.svg"
                              width="24"
                              height="24"
                           />
                        </div>
                        <div className="service-description">
                           GANs (Generative Adversarial Networks)
                        </div>
                     </li>
                  </ul>
               </div>
               <div className="service_card card_3">
                  <div className="service_card_title">
                     <h3>Machine Learning & Neural Networks</h3>
                     <p className="service_card_sub">
                        AI systems that learn from data and improve over time,
                        with models ranging from simple algorithms to deep
                        neural networks.
                     </p>
                  </div>
                  <div className="ai-ml_card_border"></div>
                  <ul className="service-list">
                     <li className="service-item">
                        <div className="icon">
                           <img
                              src="/assets/svg/service/machine1.svg"
                              width="24"
                              height="24"
                           />
                        </div>
                        <div className="service-description">
                           Transfer Learning
                        </div>
                     </li>
                     <li className="service-item">
                        <div className="icon">
                           <img
                              src="/assets/svg/service/machine2.svg"
                              width="24"
                              height="24"
                           />
                        </div>
                        <div className="service-description">
                           Deep Learning (DL)
                        </div>
                     </li>
                     <li className="service-item">
                        <div className="icon">
                           <img
                              src="/assets/svg/service/machine3.svg"
                              width="24"
                              height="24"
                           />
                        </div>
                        <div className="service-description">
                           Federated Learning
                        </div>
                     </li>
                     <li className="service-item">
                        <div className="icon">
                           <img
                              src="/assets/svg/service/machine4.svg"
                              width="24"
                              height="24"
                           />
                        </div>
                        <div className="service-description">
                           Supervised Learning
                        </div>
                     </li>
                     <li className="service-item">
                        <div className="icon">
                           <img
                              src="/assets/svg/service/machine5.svg"
                              width="24"
                              height="24"
                           />
                        </div>
                        <div className="service-description">
                           Unsupervised Learning
                        </div>
                     </li>
                     <li className="service-item">
                        <div className="icon">
                           <img
                              src="/assets/svg/service/machine6.svg"
                              width="24"
                              height="24"
                           />
                        </div>
                        <div className="service-description">
                           Reinforcement Learning (RL)
                        </div>
                     </li>
                  </ul>
               </div>
               <div className="service_card card_1">
                  <div className="service_card_title">
                     <h3>Speech & Audio Processing</h3>
                     <p className="service_card_sub">
                        AI that processes and generates speech and sound, used
                        in virtual assistants, voice recognition, and audio
                        enhancement.
                     </p>
                  </div>
                  <div className="ai-ml_card_border"></div>
                  <ul className="service-list">
                     <li className="service-item">
                        <div className="icon">
                           <img
                              src="/assets/svg/service/speech1.svg"
                              width="24"
                              height="24"
                           />
                        </div>
                        <div className="service-description">Voice Cloning</div>
                     </li>
                     <li className="service-item">
                        <div className="icon">
                           <img
                              src="/assets/svg/service/speech2.svg"
                              width="24"
                              height="24"
                           />
                        </div>
                        <div className="service-description">
                           Noise Reduction
                        </div>
                     </li>
                     <li className="service-item">
                        <div className="icon">
                           <img
                              src="/assets/svg/service/speech3.svg"
                              width="24"
                              height="24"
                           />
                        </div>
                        <div className="service-description">
                           Speech Synthesis
                        </div>
                     </li>
                     <li className="service-item">
                        <div className="icon">
                           <img
                              src="/assets/svg/service/speech4.svg"
                              width="24"
                              height="24"
                           />
                        </div>
                        <div className="service-description">
                           Speaker Diarization
                        </div>
                     </li>
                     <li className="service-item">
                        <div className="icon">
                           <img
                              src="/assets/svg/service/speech5.svg"
                              width="24"
                              height="24"
                           />
                        </div>
                        <div className="service-description">
                           Speech Recognition
                        </div>
                     </li>
                     <li className="service-item">
                        <div className="icon">
                           <img
                              src="/assets/svg/service/speech6.svg"
                              width="24"
                              height="24"
                           />
                        </div>
                        <div className="service-description">
                           Audio Enhancement
                        </div>
                     </li>
                  </ul>
               </div>
               <div className="service_card card_2">
                  <div className="service_card_title">
                     <h3>AI in Decision-Making</h3>
                     <p className="service_card_sub">
                        AI that assists in making complex decisions,
                        predictions, and recommendations based on data analysis
                        and logical reasoning.
                     </p>
                  </div>
                  <div className="ai-ml_card_border"></div>
                  <ul className="service-list">
                     <li className="service-item">
                        <div className="icon">
                           <img
                              src="/assets/svg/service/ai1.svg"
                              width="24"
                              height="24"
                           />
                        </div>
                        <div className="service-description">Fuzzy Logic</div>
                     </li>
                     <li className="service-item">
                        <div className="icon">
                           <img
                              src="/assets/svg/service/ai2.svg"
                              width="24"
                              height="24"
                           />
                        </div>
                        <div className="service-description">
                           Decision Trees
                        </div>
                     </li>
                     <li className="service-item">
                        <div className="icon">
                           <img
                              src="/assets/svg/service/ai3.svg"
                              width="24"
                              height="24"
                           />
                        </div>
                        <div className="service-description">
                           Expert Systems
                        </div>
                     </li>
                     <li className="service-item">
                        <div className="icon">
                           <img
                              src="/assets/svg/service/ai4.svg"
                              width="24"
                              height="24"
                           />
                        </div>
                        <div className="service-description">
                           Bayesian Networks
                        </div>
                     </li>
                     <li className="service-item">
                        <div className="icon">
                           <img
                              src="/assets/svg/service/ai5.svg"
                              width="24"
                              height="24"
                           />
                        </div>
                        <div className="service-description">
                           Predictive Analytics
                        </div>
                     </li>
                     <li className="service-item">
                        <div className="icon">
                           <img
                              src="/assets/svg/service/ai6.svg"
                              width="24"
                              height="24"
                           />
                        </div>
                        <div className="service-description">
                           Recommender Systems
                        </div>
                     </li>
                  </ul>
               </div>
               <div className="service_card card_3">
                  <div className="service_card_title">
                     <h3>Autonomous Systems & Robotics</h3>
                     <p className="service_card_sub">
                        AI that enables machines and robots to act autonomously, including autonomous cars and industrial automation.
                     </p>
                  </div>
                  <div className="ai-ml_card_border"></div>
                  <ul className="service-list">
                     <li className="service-item">
                        <div className="icon">
                           <img
                              src="/assets/svg/service/auto1.svg"
                              width="24"
                              height="24"
                           />
                        </div>
                        <div className="service-description">
                           Swarm Robotics
                        </div>
                     </li>
                     <li className="service-item">
                        <div className="icon">
                           <img
                              src="/assets/svg/service/auto2.svg"
                              width="24"
                              height="24"
                           />
                        </div>
                        <div className="service-description">
                           Self-Driving Cars
                        </div>
                     </li>
                     <li className="service-item">
                        <div className="icon">
                           <img
                              src="/assets/svg/service/auto3.svg"
                              width="24"
                              height="24"
                           />
                        </div>
                        <div className="service-description">
                           Humanoid Robots
                        </div>
                     </li>
                     <li className="service-item">
                        <div className="icon">
                           <img
                              src="/assets/svg/service/auto4.svg"
                              width="24"
                              height="24"
                           />
                        </div>
                        <div className="service-description">
                           Drones & Robotics
                        </div>
                     </li>
                     <li className="service-item">
                        <div className="icon">
                           <img
                              src="/assets/svg/service/auto5.svg"
                              width="24"
                              height="24"
                           />
                        </div>
                        <div className="service-description">
                           Industrial Automation
                        </div>
                     </li>
                     <li className="service-item">
                        <div className="icon">
                           <img
                              src="/assets/svg/service/auto6.svg"
                              width="24"
                              height="24"
                           />
                        </div>
                        <div className="service-description">
                           AI in Smart Manufacturing
                        </div>
                     </li>
                  </ul>
               </div>
               <div className="service_card card_1">
                  <div className="service_card_title">
                     <h3>Ethical & Adversarial AI</h3>
                     <p className="service_card_sub">
                        AI that prioritizes fairness, security, and transparency in the face of challenges like adversarial attacks as well as biased decision-making.
                     </p>
                  </div>
                  <div className="ai-ml_card_border"></div>
                  <ul className="service-list">
                     <li className="service-item">
                        <div className="icon">
                           <img
                              src="/assets/svg/service/ethic1.svg"
                              width="24"
                              height="24"
                           />
                        </div>
                        <div className="service-description">Robust AI</div>
                     </li>
                     <li className="service-item">
                        <div className="icon">
                           <img
                              src="/assets/svg/service/ethic2.svg"
                              width="24"
                              height="24"
                           />
                        </div>
                        <div className="service-description">AI Fairness</div>
                     </li>
                     <li className="service-item">
                        <div className="icon">
                           <img
                              src="/assets/svg/service/ethic3.svg"
                              width="24"
                              height="24"
                           />
                        </div>
                        <div className="service-description">AI Security</div>
                     </li>
                     <li className="service-item">
                        <div className="icon">
                           <img
                              src="/assets/svg/service/ethic4.svg"
                              width="24"
                              height="24"
                           />
                        </div>
                        <div className="service-description">
                           Bias Detection
                        </div>
                     </li>
                     <li className="service-item">
                        <div className="icon">
                           <img
                              src="/assets/svg/service/ethic5.svg"
                              width="24"
                              height="24"
                           />
                        </div>
                        <div className="service-description">
                           Adversarial Attacks
                        </div>
                     </li>
                     <li className="service-item">
                        <div className="icon">
                           <img
                              src="/assets/svg/service/ethic6.svg"
                              width="24"
                              height="24"
                           />
                        </div>
                        <div className="service-description">
                           Explainable AI (XAI)
                        </div>
                     </li>
                  </ul>
               </div>
               <div className="service_card card_2">
                  <div className="service_card_title">
                     <h3>Healthcare & Biomedical Innovation</h3>
                     <p className="service_card_sub">
                        AI that transforms healthcare research, diagnosis, and treatment, streamlining drug development, precision medicine, and healthcare automation.
                     </p>
                  </div>
                  <div className="ai-ml_card_border"></div>
                  <ul className="service-list">
                     <li className="service-item">
                        <div className="icon">
                           <img
                              src="/assets/svg/service/health1.svg"
                              width="24"
                              height="24"
                           />
                        </div>
                        <div className="service-description">
                           Medical Imaging AI
                        </div>
                     </li>
                     <li className="service-item">
                        <div className="icon">
                           <img
                              src="/assets/svg/service/health2.svg"
                              width="24"
                              height="24"
                           />
                        </div>
                        <div className="service-description">
                           Predictive Diagnostics
                        </div>
                     </li>
                     <li className="service-item">
                        <div className="icon">
                           <img
                              src="/assets/svg/service/health3.svg"
                              width="24"
                              height="24"
                           />
                        </div>
                        <div className="service-description">
                           Personalized Medicine
                        </div>
                     </li>
                     <li className="service-item">
                        <div className="icon">
                           <img
                              src="/assets/svg/service/health4.svg"
                              width="24"
                              height="24"
                           />
                        </div>
                        <div className="service-description">
                           AI-Assisted Robotic Surgery
                        </div>
                     </li>
                     <li className="service-item">
                        <div className="icon">
                           <img
                              src="/assets/svg/service/health5.svg"
                              width="24"
                              height="24"
                           />
                        </div>
                        <div className="service-description">
                           AI-Powered Drug Discovery
                        </div>
                     </li>
                     <li className="service-item">
                        <div className="icon">
                           <img
                              src="/assets/svg/service/health6.svg"
                              width="24"
                              height="24"
                           />
                        </div>
                        <div className="service-description">
                           Healthcare Chatbots & Virtual Assistants
                        </div>
                     </li>
                  </ul>
               </div>
               <div className="service_card card_3">
                  <div className="service_card_title">
                     <h3>Sentient AI & Artificial Consciousness</h3>
                     <p className="service_card_sub">
                        AI that delves into self-awareness, emotion, and adaptive learning, advancing machine intelligence toward human-like thought and decision-making.
                     </p>
                  </div>
                  <div className="ai-ml_card_border"></div>
                  <ul className="service-list">
                     <li className="service-item">
                        <div className="icon">
                           <img
                              src="/assets/svg/service/sen1.svg"
                              width="24"
                              height="24"
                           />
                        </div>
                        <div className="service-description">
                           Human-AI Symbiosis
                        </div>
                     </li>
                     <li className="service-item">
                        <div className="icon">
                           <img
                              src="/assets/svg/service/sen2.svg"
                              width="24"
                              height="24"
                           />
                        </div>
                        <div className="service-description">
                           Artificial Self-Awareness
                        </div>
                     </li>
                     <li className="service-item">
                        <div className="icon">
                           <img
                              src="/assets/svg/service/sen3.svg"
                              width="24"
                              height="24"
                           />
                        </div>
                        <div className="service-description">
                           Emotionally Intelligent AI
                        </div>
                     </li>
                     <li className="service-item">
                        <div className="icon">
                           <img
                              src="/assets/svg/service/sen4.svg"
                              width="24"
                              height="24"
                           />
                        </div>
                        <div className="service-description">
                           AI-Powered Intuition & Creativity
                        </div>
                     </li>
                     <li className="service-item">
                        <div className="icon">
                           <img
                              src="/assets/svg/service/sen5.svg"
                              width="24"
                              height="24"
                           />
                        </div>
                        <div className="service-description">
                           Mimicking Conscious Thought Processes
                        </div>
                     </li>
                     <li className="service-item">
                        <div className="icon">
                           <img
                              src="/assets/svg/service/sen6.svg"
                              width="24"
                              height="24"
                           />
                        </div>
                        <div className="service-description">
                           Self-Learning & Adaptive Neural Networks
                        </div>
                     </li>
                  </ul>
               </div>
            </div>
            <div className="features_row"></div>
         </div>
         <div className="d-sm-none d-inline">
            <div className="slider-column">
               <div className="model_train_slider container-fluid position-relative ai-ml-service mb-2">
                  <Swiper
                     modules={[Navigation, Pagination, Autoplay]}
                     slidesPerView={2}
                     spaceBetween={30}
                     centeredSlides={true}
                     loop={true}
                     autoplay={{
                        delay: 3000,
                        disableOnInteraction: false,
                     }}
                     pagination={{
                        el: '.fintach-pagination',
                        clickable: true,
                        renderBullet: (index, className) =>
                           `<span class="${className} custom-dark-bullet"></span>`,
                     }}
                     breakpoints={{
                        320: {
                           slidesPerView: 1,
                           spaceBetween: 30,
                        },
                        768: {
                           slidesPerView: 1,
                           spaceBetween: 30,
                        },
                        1025: {
                           slidesPerView: 1,
                           spaceBetween: 30,
                        },
                        1200: {
                           slidesPerView: 2,
                           spaceBetween: 30,
                        },
                     }}
                  >
                     <SwiperSlide>
                        <div className="service_card card_1 p-3">
                           <div className="service_card_title">
                              <h3>Language & Text Processing</h3>
                              <p className="service_card_sub">
                                 AI that enables machines to understand,
                                 generate, and process human language, including
                                 text-based communication and speech synthesis.
                              </p>
                           </div>
                           <div className="ai-ml_card_border"></div>
                           <ul className="service-list">
                              {[
                                 'Text-to-Speech (TTS)',
                                 'SLM (Small Language Model)',
                                 'LLM (Large Language Model)',
                                 'NLP (Natural Language Processing)',
                                 'RAG (Retrieval-Augmented Generation)',
                                 'TLM (Transformers-Based Language Models)',
                              ].map((item, index) => (
                                 <li key={index} className="service-item">
                                    <div className="icon">
                                       <img
                                          src={`/assets/svg/service/lang${
                                             index + 1
                                          }.svg`}
                                          width="12"
                                          height="12"
                                          alt={item}
                                       />
                                    </div>
                                    <div className="service-description">
                                       {item}
                                    </div>
                                 </li>
                              ))}
                           </ul>
                        </div>
                     </SwiperSlide>
                     <SwiperSlide>
                        <div className="service_card card_2 p-3">
                           <div className="service_card_title">
                              <h3>Vision & Image Processing</h3>
                              <p className="service_card_sub">
                                 AI that interprets visual data from images and
                                 videos, enabling applications like object
                                 detection, facial recognition & image
                                 generation.
                              </p>
                           </div>
                           <div className="ai-ml_card_border"></div>
                           <ul className="service-list">
                              {[
                                 'Object Detection',
                                 'Diffusion Models',
                                 'Image Segmentation',
                                 'CV (Computer Vision)',
                                 'OCR (Optical Character Recognition)',
                                 'GANs (Generative Adversarial Networks)',
                              ].map((item, index) => (
                                 <li key={index} className="service-item">
                                    <div className="icon">
                                       <img
                                          src={`/assets/svg/service/vision${
                                             index + 1
                                          }.svg`}
                                          width="12"
                                          height="12"
                                          alt={item}
                                       />
                                    </div>
                                    <div className="service-description">
                                       {item}
                                    </div>
                                 </li>
                              ))}
                           </ul>
                        </div>
                     </SwiperSlide>
                     <SwiperSlide>
                        <div className="service_card card_3 p-3">
                           <div className="service_card_title">
                              <h3>Machine Learning & Neural Networks</h3>
                              <p className="service_card_sub">
                                 AI systems that learn from data and improve
                                 over time, with models ranging from simple
                                 algorithms to deep neural networks.
                              </p>
                           </div>
                           <div className="ai-ml_card_border"></div>
                           <ul className="service-list">
                              <li className="service-item">
                                 <div className="icon">
                                    <img
                                       src="/assets/svg/service/machine1.svg"
                                       width="12"
                                       height="12"
                                    />
                                 </div>
                                 <div className="service-description">
                                    Transfer Learning
                                 </div>
                              </li>
                              <li className="service-item">
                                 <div className="icon">
                                    <img
                                       src="/assets/svg/service/machine2.svg"
                                       width="12"
                                       height="12"
                                    />
                                 </div>
                                 <div className="service-description">
                                    Deep Learning (DL)
                                 </div>
                              </li>
                              <li className="service-item">
                                 <div className="icon">
                                    <img
                                       src="/assets/svg/service/machine3.svg"
                                       width="12"
                                       height="12"
                                    />
                                 </div>
                                 <div className="service-description">
                                    Federated Learning
                                 </div>
                              </li>
                              <li className="service-item">
                                 <div className="icon">
                                    <img
                                       src="/assets/svg/service/machine4.svg"
                                       width="12"
                                       height="12"
                                    />
                                 </div>
                                 <div className="service-description">
                                    Supervised Learning
                                 </div>
                              </li>
                              <li className="service-item">
                                 <div className="icon">
                                    <img
                                       src="/assets/svg/service/machine5.svg"
                                       width="12"
                                       height="12"
                                    />
                                 </div>
                                 <div className="service-description">
                                    Unsupervised Learning
                                 </div>
                              </li>
                              <li className="service-item">
                                 <div className="icon">
                                    <img
                                       src="/assets/svg/service/machine6.svg"
                                       width="12"
                                       height="12"
                                    />
                                 </div>
                                 <div className="service-description">
                                    Reinforcement Learning (RL)
                                 </div>
                              </li>
                           </ul>
                        </div>
                     </SwiperSlide>
                     <SwiperSlide>
                        <div className="service_card card_1 p-3">
                           <div className="service_card_title">
                              <h3>Speech & Audio Processing</h3>
                              <p className="service_card_sub">
                                 AI that processes and generates speech and
                                 sound, used in virtual assistants, voice
                                 recognition, and audio enhancement.
                              </p>
                           </div>
                           <div className="ai-ml_card_border"></div>
                           <ul className="service-list">
                              <li className="service-item">
                                 <div className="icon">
                                    <img
                                       src="/assets/svg/service/speech1.svg"
                                       width="12"
                                       height="12"
                                    />
                                 </div>
                                 <div className="service-description">
                                    Voice Cloning
                                 </div>
                              </li>
                              <li className="service-item">
                                 <div className="icon">
                                    <img
                                       src="/assets/svg/service/speech2.svg"
                                       width="12"
                                       height="12"
                                    />
                                 </div>
                                 <div className="service-description">
                                    Noise Reduction
                                 </div>
                              </li>
                              <li className="service-item">
                                 <div className="icon">
                                    <img
                                       src="/assets/svg/service/speech3.svg"
                                       width="12"
                                       height="12"
                                    />
                                 </div>
                                 <div className="service-description">
                                    Speech Synthesis
                                 </div>
                              </li>
                              <li className="service-item">
                                 <div className="icon">
                                    <img
                                       src="/assets/svg/service/speech4.svg"
                                       width="12"
                                       height="12"
                                    />
                                 </div>
                                 <div className="service-description">
                                    Speaker Diarization
                                 </div>
                              </li>
                              <li className="service-item">
                                 <div className="icon">
                                    <img
                                       src="/assets/svg/service/speech5.svg"
                                       width="12"
                                       height="12"
                                    />
                                 </div>
                                 <div className="service-description">
                                    Speech Recognition
                                 </div>
                              </li>
                              <li className="service-item">
                                 <div className="icon">
                                    <img
                                       src="/assets/svg/service/speech6.svg"
                                       width="12"
                                       height="12"
                                    />
                                 </div>
                                 <div className="service-description">
                                    Audio Enhancement
                                 </div>
                              </li>
                           </ul>
                        </div>
                     </SwiperSlide>
                     <SwiperSlide>
                        <div className="service_card card_2 p-3">
                           <div className="service_card_title">
                              <h3>AI in Decision-Making</h3>
                              <p className="service_card_sub">
                                 AI that assists in making complex decisions,
                                 predictions, and recommendations based on data
                                 analysis and logical reasoning.
                              </p>
                           </div>
                           <div className="ai-ml_card_border"></div>
                           <ul className="service-list">
                              <li className="service-item">
                                 <div className="icon">
                                    <img
                                       src="/assets/svg/service/ai1.svg"
                                       width="12"
                                       height="12"
                                    />
                                 </div>
                                 <div className="service-description">
                                    Fuzzy Logic
                                 </div>
                              </li>
                              <li className="service-item">
                                 <div className="icon">
                                    <img
                                       src="/assets/svg/service/ai2.svg"
                                       width="12"
                                       height="12"
                                    />
                                 </div>
                                 <div className="service-description">
                                    Decision Trees
                                 </div>
                              </li>
                              <li className="service-item">
                                 <div className="icon">
                                    <img
                                       src="/assets/svg/service/ai3.svg"
                                       width="12"
                                       height="12"
                                    />
                                 </div>
                                 <div className="service-description">
                                    Expert Systems
                                 </div>
                              </li>
                              <li className="service-item">
                                 <div className="icon">
                                    <img
                                       src="/assets/svg/service/ai4.svg"
                                       width="12"
                                       height="12"
                                    />
                                 </div>
                                 <div className="service-description">
                                    Bayesian Networks
                                 </div>
                              </li>
                              <li className="service-item">
                                 <div className="icon">
                                    <img
                                       src="/assets/svg/service/ai5.svg"
                                       width="12"
                                       height="12"
                                    />
                                 </div>
                                 <div className="service-description">
                                    Predictive Analytics
                                 </div>
                              </li>
                              <li className="service-item">
                                 <div className="icon">
                                    <img
                                       src="/assets/svg/service/ai6.svg"
                                       width="12"
                                       height="12"
                                    />
                                 </div>
                                 <div className="service-description">
                                    Recommender Systems
                                 </div>
                              </li>
                           </ul>
                        </div>
                     </SwiperSlide>
                     <SwiperSlide>
                        <div className="service_card card_3 p-3">
                           <div className="service_card_title">
                              <h3>Autonomous Systems & Robotics</h3>
                              <p className="service_card_sub">
                                 AI that enables machines and robots to perform
                                 tasks independently, including self-driving
                                 vehicles and industrial automation.
                              </p>
                           </div>
                           <div className="ai-ml_card_border"></div>
                           <ul className="service-list">
                              <li className="service-item">
                                 <div className="icon">
                                    <img
                                       src="/assets/svg/service/auto1.svg"
                                       width="12"
                                       height="12"
                                    />
                                 </div>
                                 <div className="service-description">
                                    Swarm Robotics
                                 </div>
                              </li>
                              <li className="service-item">
                                 <div className="icon">
                                    <img
                                       src="/assets/svg/service/auto2.svg"
                                       width="12"
                                       height="12"
                                    />
                                 </div>
                                 <div className="service-description">
                                    Self-Driving Cars
                                 </div>
                              </li>
                              <li className="service-item">
                                 <div className="icon">
                                    <img
                                       src="/assets/svg/service/auto3.svg"
                                       width="12"
                                       height="12"
                                    />
                                 </div>
                                 <div className="service-description">
                                    Humanoid Robots
                                 </div>
                              </li>
                              <li className="service-item">
                                 <div className="icon">
                                    <img
                                       src="/assets/svg/service/auto4.svg"
                                       width="12"
                                       height="12"
                                    />
                                 </div>
                                 <div className="service-description">
                                    Drones & Robotics
                                 </div>
                              </li>
                              <li className="service-item">
                                 <div className="icon">
                                    <img
                                       src="/assets/svg/service/auto5.svg"
                                       width="12"
                                       height="12"
                                    />
                                 </div>
                                 <div className="service-description">
                                    Industrial Automation
                                 </div>
                              </li>
                              <li className="service-item">
                                 <div className="icon">
                                    <img
                                       src="/assets/svg/service/auto6.svg"
                                       width="12"
                                       height="12"
                                    />
                                 </div>
                                 <div className="service-description">
                                    AI in Smart Manufacturing
                                 </div>
                              </li>
                           </ul>
                        </div>
                     </SwiperSlide>
                     <SwiperSlide>
                        <div className="service_card card_1 p-3">
                           <div className="service_card_title">
                              <h3>Ethical & Adversarial AI</h3>
                              <p className="service_card_sub">
                                 AI that focuses on fairness, security, and
                                 transparency while addressing threats such as
                                 adversarial attacks and biased decision-making.
                              </p>
                           </div>
                           <div className="ai-ml_card_border"></div>
                           <ul className="service-list">
                              <li className="service-item">
                                 <div className="icon">
                                    <img
                                       src="/assets/svg/service/ethic1.svg"
                                       width="12"
                                       height="12"
                                    />
                                 </div>
                                 <div className="service-description">
                                    Robust AI
                                 </div>
                              </li>
                              <li className="service-item">
                                 <div className="icon">
                                    <img
                                       src="/assets/svg/service/ethic2.svg"
                                       width="12"
                                       height="12"
                                    />
                                 </div>
                                 <div className="service-description">
                                    AI Fairness
                                 </div>
                              </li>
                              <li className="service-item">
                                 <div className="icon">
                                    <img
                                       src="/assets/svg/service/ethic3.svg"
                                       width="12"
                                       height="12"
                                    />
                                 </div>
                                 <div className="service-description">
                                    AI Security
                                 </div>
                              </li>
                              <li className="service-item">
                                 <div className="icon">
                                    <img
                                       src="/assets/svg/service/ethic4.svg"
                                       width="12"
                                       height="12"
                                    />
                                 </div>
                                 <div className="service-description">
                                    Bias Detection
                                 </div>
                              </li>
                              <li className="service-item">
                                 <div className="icon">
                                    <img
                                       src="/assets/svg/service/ethic5.svg"
                                       width="12"
                                       height="12"
                                    />
                                 </div>
                                 <div className="service-description">
                                    Adversarial Attacks
                                 </div>
                              </li>
                              <li className="service-item">
                                 <div className="icon">
                                    <img
                                       src="/assets/svg/service/ethic6.svg"
                                       width="12"
                                       height="12"
                                    />
                                 </div>
                                 <div className="service-description">
                                    Explainable AI (XAI)
                                 </div>
                              </li>
                           </ul>
                        </div>
                     </SwiperSlide>
                     <SwiperSlide>
                        <div className="service_card card_2 p-3">
                           <div className="service_card_title">
                              <h3>Healthcare & Biomedical Innovation</h3>
                              <p className="service_card_sub">
                                 AI that transforms medical research, diagnosis,
                                 and treatment, enabling faster drug discovery,
                                 precision medicine, and advanced healthcare
                                 automation.
                              </p>
                           </div>
                           <div className="ai-ml_card_border"></div>
                           <ul className="service-list">
                              <li className="service-item">
                                 <div className="icon">
                                    <img
                                       src="/assets/svg/service/health1.svg"
                                       width="12"
                                       height="12"
                                    />
                                 </div>
                                 <div className="service-description">
                                    Medical Imaging AI
                                 </div>
                              </li>
                              <li className="service-item">
                                 <div className="icon">
                                    <img
                                       src="/assets/svg/service/health2.svg"
                                       width="12"
                                       height="12"
                                    />
                                 </div>
                                 <div className="service-description">
                                    Predictive Diagnostics
                                 </div>
                              </li>
                              <li className="service-item">
                                 <div className="icon">
                                    <img
                                       src="/assets/svg/service/health3.svg"
                                       width="12"
                                       height="12"
                                    />
                                 </div>
                                 <div className="service-description">
                                    Personalized Medicine
                                 </div>
                              </li>
                              <li className="service-item">
                                 <div className="icon">
                                    <img
                                       src="/assets/svg/service/health4.svg"
                                       width="12"
                                       height="12"
                                    />
                                 </div>
                                 <div className="service-description">
                                    AI-Assisted Robotic Surgery
                                 </div>
                              </li>
                              <li className="service-item">
                                 <div className="icon">
                                    <img
                                       src="/assets/svg/service/health5.svg"
                                       width="12"
                                       height="12"
                                    />
                                 </div>
                                 <div className="service-description">
                                    AI-Powered Drug Discovery
                                 </div>
                              </li>
                              <li className="service-item">
                                 <div className="icon">
                                    <img
                                       src="/assets/svg/service/health6.svg"
                                       width="12"
                                       height="12"
                                    />
                                 </div>
                                 <div className="service-description">
                                    Healthcare Chatbots & Virtual Assistants
                                 </div>
                              </li>
                           </ul>
                        </div>
                     </SwiperSlide>
                     <SwiperSlide>
                        <div className="service_card card_3 p-3">
                           <div className="service_card_title">
                              <h3>Sentient AI & Artificial Consciousness</h3>
                              <p className="service_card_sub">
                                 AI that explores self-awareness, emotions, and
                                 adaptive learning, pushing the boundaries of
                                 machine intelligence toward human-like
                                 cognition and decision-making.
                              </p>
                           </div>
                           <div className="ai-ml_card_border"></div>
                           <ul className="service-list">
                              <li className="service-item">
                                 <div className="icon">
                                    <img
                                       src="/assets/svg/service/sen1.svg"
                                       width="12"
                                       height="12"
                                    />
                                 </div>
                                 <div className="service-description">
                                    Human-AI Symbiosis
                                 </div>
                              </li>
                              <li className="service-item">
                                 <div className="icon">
                                    <img
                                       src="/assets/svg/service/sen2.svg"
                                       width="12"
                                       height="12"
                                    />
                                 </div>
                                 <div className="service-description">
                                    Artificial Self-Awareness
                                 </div>
                              </li>
                              <li className="service-item">
                                 <div className="icon">
                                    <img
                                       src="/assets/svg/service/sen3.svg"
                                       width="12"
                                       height="12"
                                    />
                                 </div>
                                 <div className="service-description">
                                    Emotionally Intelligent AI
                                 </div>
                              </li>
                              <li className="service-item">
                                 <div className="icon">
                                    <img
                                       src="/assets/svg/service/sen4.svg"
                                       width="12"
                                       height="12"
                                    />
                                 </div>
                                 <div className="service-description">
                                    AI-Powered Intuition & Creativity
                                 </div>
                              </li>
                              <li className="service-item">
                                 <div className="icon">
                                    <img
                                       src="/assets/svg/service/sen5.svg"
                                       width="12"
                                       height="12"
                                    />
                                 </div>
                                 <div className="service-description">
                                    Mimicking Conscious Thought Processes
                                 </div>
                              </li>
                              <li className="service-item">
                                 <div className="icon">
                                    <img
                                       src="/assets/svg/service/sen6.svg"
                                       width="12"
                                       height="12"
                                    />
                                 </div>
                                 <div className="service-description">
                                    Self-Learning & Adaptive Neural Networks
                                 </div>
                              </li>
                           </ul>
                        </div>
                     </SwiperSlide>
                  </Swiper>

                  <div className="d-xl-none d-flex align-items-center justify-content-center mt-2">
                     <span className="d-flex align-items-center justify-content-center fintach-pagination"></span>
                  </div>
               </div>
            </div>
         </div>
      </section>
   )
}
